
/**
 * @ngdoc directive
 * @name missions
 *
 * @description
 * Missions
 */
module.directive('missions', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            list: '='
        },
        template:
                '<div class="aqua-missions">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-missions--title">{{label}}</span></h2>' +

                '    <div class="grid grid-gutter">' +

                '      <div class="grid-4 grid-4-m grid-12-s grid grid-v" ng-repeat="mission in list">' +
                '        <a ng-href="{{mission.url}}" class="aqua-missions--link grid-12-s"><img class="aqua-missions--item-image" aqua-src="{{mission.src}}" alt="{{mission.title}}" /></a>' +
                '        <a ng-href="{{mission.url}}" class="aqua-missions--link grid-12-s"><h3 class="aqua-missions--item-title {{mission.title | lowercase}}">{{mission.title}}</h3></a>' +
                '        <p class="aqua-missions--item-text">{{mission.alt}}</p>' +
                '      </div>' +

                '    </div>' +

                '  </div>' +
                '</div>'
    };
});
